import { Store } from "redux";
import { DistributorListItem, LoadableThermostat, OJEUMWD3Thermostat } from "./models";
import {
    ReceiveAllOJEUMWD3Thermostats,
    ReceiveNewOJEUMWD3Thermostat,
    RemoveOJEUMWD3Thermostat,
    UpdateOJEUMWD3ThermostatState,
    ReceiveLoadableThermostats,
    AddLoadableThermostat,
    UpdateLoadableThermostat,
    RemoveLoadableThermostat,
    ReceiveDistributorSearchResult,
    ReceiveUserSearchResult
} from "./actionTypes";
import { buildHub } from "../../ApiGateway";
import { HubConnectionState } from "@microsoft/signalr";
import { UserAccountItem } from "../UserAccountItem";


// Create OJEUMWD3 hub
export const OJEUMWD3Hub = buildHub("OJEUMWD3Hub");

const mapStringToDate = (t: OJEUMWD3Thermostat) => {
    if (!!t.mode.holdUntilEndTime && typeof (t.mode.holdUntilEndTime) === "string") {
        t.mode.holdUntilEndTime = new Date(t.mode.holdUntilEndTime);
    }
};

/**
 * Connect to OJEUMWD3 SignalR hub and register handlers.
 */
export function connectToOJEUMWD3Hub(store: Store) {
    if (OJEUMWD3Hub.state !== HubConnectionState.Disconnected) {
        return;
    }

    OJEUMWD3Hub.start()
        .catch(err => console.error("Failed to start OJEUMWD3Hub", err));

    OJEUMWD3Hub.on("ReceiveAllThermostats", (thermostats: OJEUMWD3Thermostat[]) => {
        thermostats.forEach(mapStringToDate);
        store.dispatch({ type: "RECEIVE_ALL_OJEUMWD3_THERMOSTATS", thermostats } as ReceiveAllOJEUMWD3Thermostats);
    });

    OJEUMWD3Hub.on("ReceiveNewThermostat", (thermostat: OJEUMWD3Thermostat) => {
        mapStringToDate(thermostat);
        console.log(thermostat);
        store.dispatch({ type: "RECEIVE_NEW_OJEUMWD3_THERMOSTAT", thermostat } as ReceiveNewOJEUMWD3Thermostat);
    });

    OJEUMWD3Hub.on("UpdateThermostatState", (thermostat: OJEUMWD3Thermostat) => {
        mapStringToDate(thermostat);
        store.dispatch({ type: "UPDATE_OJEUMWD3_THERMOSTAT_STATE", thermostat } as UpdateOJEUMWD3ThermostatState);
    });

    OJEUMWD3Hub.on("RemoveThermostat", (id: string) => {
        store.dispatch({ type: "REMOVE_OJEUMWD3_THERMOSTAT", id } as RemoveOJEUMWD3Thermostat);
    });

    OJEUMWD3Hub.on("ReceiveLoadableThermostats", (thermostats: LoadableThermostat[]) => {
        store.dispatch({ type: "RECEIVE_LOADABLE_OJEUMWD3_THERMOSTATS", thermostats } as ReceiveLoadableThermostats);
    });

    OJEUMWD3Hub.on("RemoveLoadableThermostat", (id: string) => {
        store.dispatch({ type: "REMOVE_LOADABLE_OJEUMWD3_THERMOSTAT", id } as RemoveLoadableThermostat);
    });

    OJEUMWD3Hub.on("AddLoadableThermostat", (thermostat: LoadableThermostat) => {
        store.dispatch({ type: "ADD_LOADABLE_OJEUMWD3_THERMOSTAT", thermostat } as AddLoadableThermostat);
    });

    OJEUMWD3Hub.on("UpdateLoadableThermostat", (thermostat: LoadableThermostat) => {
        store.dispatch({ type: "UPDATE_LOADABLE_OJEUMWD3_THERMOSTAT", thermostat } as UpdateLoadableThermostat);
    });

    OJEUMWD3Hub.on("ReceiveDistributorSearchResult", (distributors: DistributorListItem[]) => {
        store.dispatch({ type: "RECEIVE_DISTRIBUTOR_SEARCH_RESULT", distributors } as ReceiveDistributorSearchResult);
    });

    OJEUMWD3Hub.on("ReceiveUserSearchResult", (users: UserAccountItem[]) => {
        store.dispatch({ type: "RECEIVE_USER_SEARCH_RESULT", users } as ReceiveUserSearchResult);
    });
}